import { useParams } from 'react-router-dom';

import { useAppSelector } from '@/store/hooks';
import { getWorkingProject } from '@/store/slices/project/selectors';
import { getDefaultLanguage } from '@/utils/get-default-language';
import Text from '@ui/text/text/text';
import Link from '@ui/links/link';

type SessionBreadcrumbsProps = {
  sessionUuid: string;
};

const SessionBreadcrumbs = ({ sessionUuid }: SessionBreadcrumbsProps) => {
  const project = useAppSelector(getWorkingProject);
  const params = useParams();

  const defaultLanguage = getDefaultLanguage(project);
  const language = params?.language || defaultLanguage;

  const projectName = project?.name;
  const sessions = project?.sessions;
  const session = sessions?.find((s) => s.uuid === sessionUuid);

  if (!project) return null;
  if (!session) return null;
  return (
    <div className="flex fd-row jc-flex-start ai-center width-100-percent" data-component="SessionBreadcrumbs">
      <Text clamp={1} whiteSpace="normal" wordBreak="break-all" className="max-width-50-percent">
        <Link
          textColor="var(--gray-400)"
          hoverTextColor="var(--gray-100)"
          focusTextColor="var(--gray-100)"
          focusBackgroundColor="var(--gray-800)"
          applyFocusStatesToAllChildren
          to={`/project/edit/${project.uuid}/${language}`}
        >
          <Text className="S1">
            <Text tag="span" wordBreak="break-all" className="padding-r-4">
              {projectName}
            </Text>
          </Text>
        </Link>
      </Text>
      <Text className="S1" color="var(--gray-400)">
        /
      </Text>
      <Text clamp={1} whiteSpace="normal" wordBreak="break-all" className="S1 padding-r-4" color="var(--gray-200)">
        <Text tag="span" wordBreak="break-all" className="padding-l-4">
          {session.title?.[language] || session.title.base}
        </Text>
      </Text>
    </div>
  );
};

export default SessionBreadcrumbs;
